export const DEFAULT_META = {
  description: '',
  title: '',
  keywords: '',
};

export const REALTORS_META = {
  description:
    'Выбирайте риелтора или агента по недвижимости в каталоге Циан: проверенные специалисты, отзывы и рейтинг. Сравните анкеты и обратитесь к агенту напрямую.',
  title: 'Риелторы и агенты по недвижимости — найти и выбрать | Циан',
  keywords: '',
};
